import { FunctionComponent, ReactElement } from 'react';
import TextField from '@/components/ui/form-inputs/TextField';
import { SITE_FORM_KEY } from '@/shared/constants/form-keys';
import SiteFormSection from '../components/SiteFormSection';
import { SiteFormSectionProps } from './types';

const SectionMainPointOfContact: FunctionComponent<SiteFormSectionProps> = ({
	formModel,
	setFormModel,
}): ReactElement => (
	<SiteFormSection
		title="Main point of contact"
		description="Enter the full name, title and email of the person you should contact for this site."
		width="360px"
	>
		<TextField
			name="siteAdminName"
			label="Site administrator (optional)"
			formKey={SITE_FORM_KEY}
			value={formModel?.siteAdminName}
			onChange={(event) => setFormModel({ ...formModel, siteAdminName: event.target.value })}
		/>
		<TextField
			name="siteAdminTitle"
			label="Site administrator title (optional)"
			formKey={SITE_FORM_KEY}
			value={formModel?.siteAdminTitle}
			onChange={(event) => setFormModel({ ...formModel, siteAdminTitle: event.target.value })}
		/>
		<TextField
			name="siteAdminEmail"
			label="Email (optional)"
			formKey={SITE_FORM_KEY}
			value={formModel?.siteAdminEmail}
			onChange={(event) => setFormModel({ ...formModel, siteAdminEmail: event.target.value })}
		/>
	</SiteFormSection>
);

export default SectionMainPointOfContact;
